import '../styles/TechnologiesCloud.scss'
import src1 from "../images/techologies_page/technologies_more_card_icon_first.png"
import src2 from "../images/techologies_page/technologies_more_card_icon_second.png"
import src3 from "../images/techologies_page/technologies_more_card_icon_third.png"
import {useNavigate} from "react-router-dom";

export const TechnologiesMore = () => {
    const cards = [
      {
        imageSrc: src1,
        title: 'Reliable cloud',
        description:
          'Secure website hosting ensures the neural network powers real-time, multifunctional capabilities — seamless and secure.',
      },
      {
        imageSrc: src2,
        title: 'Mid-Air Haptics',
        description:
          'Alnair uses a motion control camera and haptic effects. This lets you interact with it using touch-like sensations and gesture controls.',
      },
      {
        imageSrc: src3,
        title: 'Human-machine interaction',
        description:
          'An interactive kiosk or projector offers an engaging experience, allowing users to visually interact with Alnair.',
      },
    ];

    return <>
        <div className="tech-more-cards-wrapper">
            {cards && cards.map((item, index) => {
                return <div key={index} className="tech-more-cards-column">
                    <div className="tech-more-card">
                        <div className="card-icon">
                            <img src={item.imageSrc} alt={`item ${index}`}/>
                        </div>
                        <div className="card-title">
                            {item.title}
                        </div>
                        <div className="card-description">
                            {item.description}
                        </div>
                    </div>
                </div>
            })}
        </div>
    </>
}